/** CapCut-style gate: layers are free to add + preview, but exporting a clip
 *  that contains any layer requires PRO. */
export function canExportWithLayers(
  { isPro, layerCount }: { isPro: boolean; layerCount: number },
): boolean {
  return layerCount === 0 || isPro;
}
